<script setup lang="ts">
import CommentsThread from '@/components/comments/CommentsThread.vue';

defineProps<{
  taskId: string;
}>();
</script>

<template>
  <section>
    <div class="mb-3">
      <p class="text-base font-semibold text-foreground">Notes & Comments</p>
      <p class="text-sm text-muted-foreground">Keep task notes, comments, and updates in a dedicated thread.</p>
    </div>
    <CommentsThread
      entity-type="task"
      :entity-id="taskId"
      title="Task comments"
      placeholder="Add a task update..."
    />
  </section>
</template>
